import { Field, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import {
  StSiteMasterSection,
  StSiteMasterSectionTitle,
} from 'components/SiteMaster/SiteMaster.styles';
import { useSiteMasterRouteFields } from 'components/SiteMaster/utils';

type SiteContactDetailProps = ComponentProps & {
  fields: {
    sectionTitle?: Field<string>;
    siteAdvantagesText?: Field<string>;
  };
};

const SiteContactDetail = (props: SiteContactDetailProps): JSX.Element => {
  const routeFields = useSiteMasterRouteFields();

  return (
    <StSiteMasterSection>
      <StSiteMasterSectionTitle>
        <Text field={props.fields.sectionTitle} />
      </StSiteMasterSectionTitle>
      {props.fields.siteAdvantagesText?.value && (
        <Text tag="p" field={props.fields.siteAdvantagesText} />
      )}
      {routeFields.siteAdvantages && <RichText field={routeFields.siteAdvantages} tag="div" />}
    </StSiteMasterSection>
  );
};

export default SiteContactDetail;
